import { render, staticRenderFns } from "./twoActivity.vue?vue&type=template&id=2bec1f16&scoped=true&"
import script from "./twoActivity.vue?vue&type=script&lang=js&"
export * from "./twoActivity.vue?vue&type=script&lang=js&"
import style0 from "./twoActivity.vue?vue&type=style&index=0&id=2bec1f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec1f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bec1f16')) {
      api.createRecord('2bec1f16', component.options)
    } else {
      api.reload('2bec1f16', component.options)
    }
    module.hot.accept("./twoActivity.vue?vue&type=template&id=2bec1f16&scoped=true&", function () {
      api.rerender('2bec1f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/twoActivity.vue"
export default component.exports